import React from 'react';

import * as production from 'react/jsx-runtime';
import rehypeReact from 'rehype-react';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import { unified } from 'unified';

import { htmlStyles } from './Markdown.styles';
import { MarkdownLink } from './MarkdownLink';
import { MotionBox } from '../Animation/MotionBox/MotionBox';

const processor = unified()
	.use(remarkParse)
	.use(remarkRehype, { allowDangerousHTML: true })
	.use(rehypeReact, {
		...production,
		components: {
			// Use CustomLink instead of <a>
			a: MarkdownLink,
		},
	});

export const Markdown = ({ content, ...rest }) => {
	return (
		<MotionBox sx={htmlStyles} {...rest}>
			{processor.processSync(content).result}
		</MotionBox>
	);
};
